export const SCHEDULES_REQUEST = "SCHEDULES_REQUEST";
export const SCHEDULES_SUCCESS = "SCHEDULES_SUCCESS";
export const SCHEDULES_FAIL = "SCHEDULES_FAIL";
export const SCHEDULES_RESET = "SCHEDULES_RESET";


export const CUSTOM_SCHEDULES_REQUEST = 'CUSTOM_SCHEDULES_REQUEST';
export const CUSTOM_SCHEDULES_SUCCESS = 'CUSTOM_SCHEDULES_SUCCESS';
export const CUSTOM_SCHEDULES_FAIL = 'CUSTOM_SCHEDULES_FAIL';
export const CUSTOM_SCHEDULES_RESET = 'CUSTOM_SCHEDULES_RESET';